import { render, staticRenderFns } from "./BSignUpSMSCodeStep.vue?vue&type=template&id=67b7ec40&"
import script from "./BSignUpSMSCodeStep.vue?vue&type=script&lang=ts&"
export * from "./BSignUpSMSCodeStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports